// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import VerifyRequestModel from '../../model/verify-request-model';
import VerifyRequestDTO from '../dto/verify-request-dto';

export default abstract class VerifyRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<VerifyRequestDTO>) {
    super();
    if (data) {
      this.code = data.code;
    }
  }
  /**
  */
  'code'?: string;

  static toModel(dto: DeepPartial<VerifyRequestDTO>): VerifyRequestModel;
  static toModel(dto: DeepPartial<VerifyRequestDTO> | undefined | null): VerifyRequestModel | undefined;
  static toModel(dto: DeepPartial<VerifyRequestDTO> | undefined | null): VerifyRequestModel | undefined {
    return dto ? new VerifyRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<VerifyRequestModel> | VerifyRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'code': unwrapped.code,
    } as VerifyRequestDTO;
  }
}
